import { __extends, __assign, __spreadArray } from 'tslib';
import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-price-lockup.css';
var getClassNameList = classNames.bind(styles);
var UitkPriceLockupAlign;
(function (UitkPriceLockupAlign) {
  UitkPriceLockupAlign["LEFT"] = "start";
  UitkPriceLockupAlign["RIGHT"] = "end";
})(UitkPriceLockupAlign || (UitkPriceLockupAlign = {}));
var RenderStrikeThroughTrigger = function (props) {
  var strikeThroughPrice = props.strikeThroughPrice,
    strikeThroughTrigger = props.strikeThroughTrigger,
    a11yStrikeThroughDialogTrigger = props.a11yStrikeThroughDialogTrigger,
    stids = props.stids;
  var infoIcon = React.createElement(UitkIcon, {
    name: "info_outline",
    size: UitkIconSize.SMALL
  });
  var strikeThroughElement = React.createElement("span", {
    "data-stid": (stids === null || stids === void 0 ? void 0 : stids.strikeThroughId) || ''
  }, strikeThroughPrice);
  var triggerChildren = [infoIcon, strikeThroughElement];
  var childrenArray = React.Children.toArray(strikeThroughTrigger);
  var firstChild = childrenArray[0];
  var triggerClassName = '';
  if (firstChild.props.className) {
    triggerClassName = firstChild.props.className;
  }
  var strikeThroughClassNames = getClassNameList('uitk-price-strikethrough', triggerClassName);
  var decoratedTrigger = React.cloneElement.apply(React, __spreadArray([strikeThroughTrigger, {
    'aria-label': a11yStrikeThroughDialogTrigger,
    className: strikeThroughClassNames
  }], triggerChildren, false));
  return decoratedTrigger;
};
RenderStrikeThroughTrigger.displayName = 'RenderStrikeThroughTrigger';
var UitkPriceLockup = /** @class */function (_super) {
  __extends(UitkPriceLockup, _super);
  function UitkPriceLockup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  UitkPriceLockup.prototype.priceSubtext = function (subtext, isPadded, stid) {
    var paddingClass = isPadded ? "".concat(UitkPriceLockup.priceSubtextBaseClassName, "-padded") : "".concat(UitkPriceLockup.priceSubtextBaseClassName, "-unpadded");
    if (subtext.length > 0 && Array.isArray(subtext)) {
      var subtextList = subtext.map(function (text, index) {
        return React.createElement("div", {
          className: getClassNameList(UitkPriceLockup.priceSubtextBaseClassName),
          key: "price-subtext-".concat(index)
        }, text);
      });
      return React.createElement("div", {
        "data-stid": stid || '',
        className: getClassNameList(paddingClass),
        "aria-hidden": "true"
      }, subtextList);
    }
    return React.createElement("div", {
      "data-stid": stid || '',
      className: getClassNameList(UitkPriceLockup.priceSubtextBaseClassName, paddingClass),
      "aria-hidden": "true"
    }, subtext);
  };
  /**
   *
   * @deprecated UitkPriceLockup is deprecated, as it can be made
   * using readily available UITK components. A suitable pattern may be available
   * in the SharedUI library.
   */
  UitkPriceLockup.prototype.render = function () {
    var _a = this.props,
      className = _a.className,
      align = _a.align,
      lockupPrice = _a.lockupPrice,
      lockupFormattedPoints = _a.lockupFormattedPoints,
      strikeThroughPrice = _a.strikeThroughPrice,
      priceSubtextFirst = _a.priceSubtextFirst,
      priceSubtextBold = _a.priceSubtextBold,
      priceSubtextStandard = _a.priceSubtextStandard,
      a11yPrice = _a.a11yPrice,
      a11yStrikeThroughDialogTrigger = _a.a11yStrikeThroughDialogTrigger,
      strikeThroughTrigger = _a.strikeThroughTrigger,
      stids = _a.stids,
      isPointsFirst = _a.isPointsFirst,
      leadingCaption = _a.leadingCaption,
      isStrikeThroughFirst = _a.isStrikeThroughFirst;
    var baseClass = 'uitk-price';
    var cssClassNames = getClassNameList("".concat(baseClass, "-lockup"), className, align && "align-".concat(align));
    var priceStrikethroughClassName = getClassNameList("".concat(baseClass, "-strikethrough"));
    var lockupPointsClassName = getClassNameList('uitk-lockup-points');
    var lockupPriceClassName = getClassNameList('uitk-lockup-price');
    var subtextFirstStid = stids && stids.subtextFirstId;
    var subtextStandardStid = stids && stids.subtextStandardId;
    var wrapperComponent = function (props, children, tag) {
      if (tag === void 0) {
        tag = 'div';
      }
      if (!children) {
        return null;
      }
      var allProps = __assign(__assign({}, props), {
        'aria-hidden': 'true'
      });
      var components = {
        div: React.createElement("div", __assign({}, allProps), children),
        span: React.createElement("span", __assign({}, allProps), children)
      };
      return components[tag] || null;
    };
    return React.createElement("div", __assign({
      className: cssClassNames
    }, stids && stids.wrapperId && {
      'data-stid': stids.wrapperId
    }), isStrikeThroughFirst && strikeThroughTrigger && strikeThroughPrice && a11yStrikeThroughDialogTrigger && React.createElement(RenderStrikeThroughTrigger, {
      strikeThroughPrice: strikeThroughPrice,
      strikeThroughTrigger: strikeThroughTrigger,
      a11yStrikeThroughDialogTrigger: a11yStrikeThroughDialogTrigger,
      stids: stids
    }), isStrikeThroughFirst && strikeThroughPrice && !strikeThroughTrigger && wrapperComponent({
      'data-stid': (stids === null || stids === void 0 ? void 0 : stids.strikeThroughId) || '',
      className: priceStrikethroughClassName
    }, strikeThroughPrice, 'span'), isPointsFirst && lockupFormattedPoints && wrapperComponent({
      'data-stid': (stids === null || stids === void 0 ? void 0 : stids.lockupFormattedPointsId) || '',
      className: lockupPointsClassName
    }, lockupFormattedPoints, 'div'), React.createElement("section", null, React.createElement("span", {
      className: getClassNameList("".concat(baseClass, "-a11y"), 'is-visually-hidden')
    }, a11yPrice), !isStrikeThroughFirst && strikeThroughTrigger && strikeThroughPrice && a11yStrikeThroughDialogTrigger && React.createElement(RenderStrikeThroughTrigger, {
      strikeThroughPrice: strikeThroughPrice,
      strikeThroughTrigger: strikeThroughTrigger,
      a11yStrikeThroughDialogTrigger: a11yStrikeThroughDialogTrigger,
      stids: stids
    }), !isStrikeThroughFirst && strikeThroughPrice && !strikeThroughTrigger && wrapperComponent({
      'data-stid': (stids === null || stids === void 0 ? void 0 : stids.strikeThroughId) || '',
      className: priceStrikethroughClassName
    }, strikeThroughPrice, 'span'), isPointsFirst && leadingCaption && wrapperComponent({
      className: lockupPriceClassName
    }, leadingCaption, 'span'), lockupPrice && wrapperComponent({
      'data-stid': (stids === null || stids === void 0 ? void 0 : stids.lockupId) || '',
      className: lockupPriceClassName
    }, lockupPrice, 'span')), !isPointsFirst && lockupFormattedPoints && wrapperComponent({
      'data-stid': stids && stids.lockupFormattedPointsId ? stids.lockupFormattedPointsId : '',
      className: lockupPointsClassName
    }, [leadingCaption, lockupFormattedPoints], 'div'), priceSubtextFirst && this.priceSubtext(priceSubtextFirst, false, subtextFirstStid), priceSubtextBold && React.createElement("div", {
      className: getClassNameList(UitkPriceLockup.priceSubtextBaseClassName),
      "aria-hidden": "true"
    }, React.createElement("b", {
      "data-stid": (stids === null || stids === void 0 ? void 0 : stids.subtextBoldId) || ''
    }, priceSubtextBold)), priceSubtextStandard && this.priceSubtext(priceSubtextStandard, true, subtextStandardStid));
  };
  UitkPriceLockup.displayName = 'UitkPriceLockup';
  UitkPriceLockup.defaultProps = {
    align: UitkPriceLockupAlign.RIGHT,
    isPointsFirst: false,
    isStrikeThroughFirst: false
  };
  UitkPriceLockup.priceSubtextBaseClassName = 'uitk-price-subtext';
  return UitkPriceLockup;
}(React.Component);
export { RenderStrikeThroughTrigger, UitkPriceLockup, UitkPriceLockupAlign };